<template>
  <div>
    <div class="centent">
      <meta content="width=device-width,maximum-scale=1" name="viewport" />
      <div class="ewm_box"></div>
      <div class="ewm">
        <img :src="dataMsg.imageEwm" />
        <p>扫码<br />查验<br />证明</p>
      </div>
      <div class="zhaopian">
        <img :src="dataMsg.userPhoto" alt="铜仁学院省级专业技术人员继续教育培训平台" v-show="dataMsg.userPhoto != null" />
        <img src="../../assets/new/grzl_03.png" v-show="dataMsg.userPhoto == null" alt="铜仁学院省级专业技术人员继续教育培训平台" />
      </div>

      <img style="position: absolute; top: 0%; left: 0%; width: 170px; height: 46px" src="../../assets/images/headerLogo.png" />

      <div class="bac" id="img1"></div>
      <table cellpadding="0" cellspacing="0" width="700" border="1" class="abbb" id="table1">
        <tbody>
          <tr>
            <td colspan="6" class="biaot">[{{ dataMsg.year }}]年度专业技术人员继续教育学时证明</td>
          </tr>
          <tr>
            <td width="158" height="48" class="ad">班级名称</td>
            <td colspan="4">{{ dataMsg.className }}</td>
            <td width="99" rowspan="3"></td>
          </tr>
          <tr>
            <td height="50" class="ad">学员姓名</td>
            <td width="141">{{ dataMsg.realName }}</td>
            <td width="120" class="ad">身份证号</td>
            <td colspan="2">{{ dataMsg.cardNo }}</td>
          </tr>
          <tr>
            <td height="50" class="ad">学习形式</td>
            <td>网络教育</td>
            <td class="ad">完成学时</td>
            <td colspan="2">{{ dataMsg.totalCredit }}学时</td>
          </tr>
          <tr>
            <td height="0" colspan="5" class="ad"></td>
          </tr>
          <tr>
            <td height="49" class="ad">类别</td>
            <td colspan="3" class="ad">课目</td>
            <td width="97" class="ad">学时（分）</td>
            <td class="ad">考核结果</td>
          </tr>
          <tr v-for="msg in dataMsg.creditList" v-show="len != 0">
            <td height="49" class="ad">{{ msg.codeName }}</td>
            <td colspan="3" class="aleft">{{ msg.courseName }}<br /></td>
            <td>{{ msg.credit }}</td>
            <td>合格</td>
          </tr>
          <tr v-show="len == 0">
            <td height="49" class="ad" colspan="6">暂无数据！</td>
          </tr>

          <tr>
            <td height="49" class="ad">主办单位</td>
            <td colspan="5">铜仁学院</td>
          </tr>
          <tr>
            <td height="220" colspan="6">
              <div>
                <p class="qian">签证单位意见（盖章）：</p>
                <p class="gai">该学员已修完上述全部课程，经考核合格，准予结业。</p>
                <p class="anhui" style="text-align: right">
                  铜仁学院省级专业技术人员<br />
                  继续教育培训平台
                </p>
                <p class="nian">
                  <span id="time"
                    >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; {{ dataMsg.createYear }} 年 {{ dataMsg.createMonth }} 月 {{ dataMsg.createDay }} 日
                  </span>
                </p>
                <img src="../../assets/images/zhang1.png" class="cart_img" style="width: 152px; height: 149px" />
              </div>
            </td>
          </tr>
        </tbody>
      </table>

      <div align="center" style="background: #fff; width: 700px; height: 139px">
        <a
          @click="backPrev"
          style="
            height: 60px;
            float: left;
            background: #48a5cf;
            color: #fff;
            border-radius: 4px;
            line-height: 60px;
            text-align: center;
            width: 660px;
            margin: 30px 0 30px 20px;
            font-size: 36px;
            outline: none;
            text-decoration: none;
          "
          >返回</a
        >
        <div class="clear"></div>
      </div>
    </div>
  </div>
</template>
<script>
import { toCreditZM } from '../../api/zscy';
export default {
  data() {
    return {
      dataMsg: {},
      year: '',
      month: '',
      day: '',
      len: 0
    };
  },
  created() {
    // 班级id
    var params = { classId: this.$route.query.classId, userId: this.$route.query.userId,certId: this.$route.query.certId };
    toCreditZM(params).then(res => {
      this.dataMsg = res.data.data;
      // this.year = this.dataMsg.newData.slice(0, 4);
      // this.month = this.dataMsg.newData.slice(5, 7);
      // this.day = this.dataMsg.newData.slice(8, 10);
      if (res.data.data.creditList.length != 0) {
        this.len = res.data.data.creditList.length;
      }
    });
  },
  mounted() {
    this.setTableBackground();
  },
  updated() {
    this.setTableBackground();
  },
  methods: {
    backPrev() {
      this.$router.go(-1);
    },
    setTableBackground() {
      this.$nextTick(() => {
        const table = document.getElementById('table1');
        const bac = document.getElementById('img1');

        if (!table || !bac) return;

        const pieceHeight = 200; // 每张背景图的固定高度（除最后一张外）
        const tableHeight = table.offsetHeight;

        bac.style.width = table.offsetWidth + 'px';
        bac.style.height = tableHeight + 'px';
        bac.innerHTML = ''; // 清空旧内容

        const totalPieces = Math.ceil(tableHeight / pieceHeight);

        let html = '';
        for (let i = 0; i < totalPieces; i++) {
          const top = i * pieceHeight;
          let height;

          if (i === totalPieces - 1) {
            // 最后一张图：使用剩余高度
            height = `${tableHeight - top}px`;
          } else {
            height = `${pieceHeight}px`;
          }

          html += `
       
        `;
        }

        bac.innerHTML = html;
      });
    }
  }
};
</script>
<style scoped>
#table1 {
  height: auto;
}
.ewm {
  width: 80px;
  height: 80px;
  position: absolute;
  bottom: 153px;
  left: 30px;
  z-index: 1000;
}
.ewm p {
  position: absolute;
  top: 20px;
  left: 80px;
  width: 50px;
  overflow: hidden;
}
.ewm img {
  position: absolute;
  top: 10px;
  right: 10px;
  width: 70px;
  height: 70px;
}
.ewm_box {
  position: absolute;
  bottom: 146px;
  left: 19px;
  width: 130px;
  height: 85px;
  border: 1px solid #bbb;
}
.centent {
  margin: 0 auto;
  width: 700px;
  position: relative;
  min-height: 620px;
}
.bac {
  width: 700px;
  position: absolute;
  top: 0;
  left: 0;
}
.bac img {
  width: 100%;
  height: 100%;
  object-fit: cover; /* 拉伸适应容器 */
  z-index: -1;
  pointer-events: none; /* 防止遮挡点击事件 */
}
.cart_img {
  position: absolute;
  bottom: 15px;
  right: 30px;
  z-index: -1;
}
.zhaopian {
  width: 100px;
  height: 150px;
  position: absolute;
  top: 102px;
  right: 0;
}
.zhaopian img {
  width: 100px;
  height: 150px;
  position: absolute;
  top: 0;
  left: 0;
}
.qian {
  position: absolute;
  bottom: 150px;
  left: 5%;
}
.gai {
  position: absolute;
  bottom: 110px;
  left: 10%;
}
.anhui {
  position: absolute;
  bottom: 50px;
  right: 5%;
}
.nian {
  position: absolute;
  bottom: 20px;
  right: 5%;
}
.abbb {
  border-collapse: collapse;
  margin: 0 auto;
  position: relative;
}
.ad {
  font-weight: 900;
}
.aleft {
  text-align: left;
}
table tr td {
  text-align: center;
  border: 1px solid #666;
}
table tr th {
  height: 50px;
  border: 1px solid #333;
  color: #33c;
  background-color: #0cf;
}
.biaot {
  font-size: 24px;
  height: 100px;
  font-weight: 800;
}
</style>
